const createPageViewEventTags = (createPageViewTags:any) => {
    const {
      name,
      type,
      section,
      section1,
      section2,
      section3,
      lob,
      persona,
      productCategory,
      productType,
      language,
      siteType,
    } = createPageViewTags;
    return {
      name,
      type,
      section,
      section1,
      section2,
      section3,
      lob,
      persona,
      productCategory,
      productType,
      language,
      siteType,
    };
  };
  export const createCustomEventTags = (name:any, value:any, type:any, target:any) => {
    return {name, value, type, target};
  };
  const TaxDocPageTag = {
    name: 'Pensions | TaxDocuments',
    type: 'TaxDocuments',
    section: 'Pensions',
    section1: 'N/A',
    section2: 'N/A',
    section3: 'N/A',
    lob: 'Non-LOB',
    persona: 'N/A',
    productCategory: 'N/A',
    productType: 'N/A',
    language: 'english',
    siteType: 'oneamericalogin',
  };
  
  
  export const analyticsTags = {
    TaxDocPageViewTags: createPageViewEventTags(TaxDocPageTag),
    TaxDocPDFClick:  (docName: string) => createCustomEventTags(
        docName,
        'Tax Document',
        'Download',
    null,
      ),
};
  